module.exports = __webpack_public_path__ + "img/ZILLA.a0f4cd72.svg";